import { Injectable, model } from '@angular/core'
import { lastValueFrom } from 'rxjs'
import { ResultInfo, ResultInfoSingle } from '../common/api-common.interface'
import { HttpRequestService } from '../common/http-request.service'
import { AccountwithCustomer, CustomerUi, OrganizationWithCustomer } from './customers-api.interface'
import { environment } from '../../../environments/environment'
import { BizTaskApiService } from '@interserve/angular'

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  baseURL = environment.api.bisMarcheMacroBaseUrl

  constructor(
    private httpRequestService: HttpRequestService,
    private bizTaskApiServeice: BizTaskApiService,
  ){}

  // 顧客情報参照
  async SearchByCd(customerCd: string): Promise<ResultInfoSingle<CustomerUi>> {
    const url = `${this.baseURL}api/customer/searchByCd/${customerCd}`
    const ret$ = this.httpRequestService.getResultSingle<CustomerUi>(url)
    return await lastValueFrom(ret$)
  }

  // // メールアドレスで顧客検索
  // async SearchByMailAddress(mailAddress: string): Promise<ResultInfo<CustomerUi>> {
  //   const url = `${this.baseURL}api/customer/searchByMailAddress`
  //   const ret$ = this.httpRequestService.post<CustomerUi>(url, [mailAddress])
  //   return await lastValueFrom(ret$)
  // }

  // // 検索(組織CD)
  // async SearchByOrganizationCds(organizationCds: string[]): Promise<ResultInfo<OrganizationWithCustomer>> {
  //   const url = `${this.baseURL}api/customer/searchByOrganizationCds`
  //   const ret$ = this.httpRequestService.post<OrganizationWithCustomer>(url, organizationCds)
  //   return await lastValueFrom(ret$)
  // }

  // // 顧客を登録
  // async Create(payload: CustomerUi[], organizationCd?: string): Promise<ResultInfo<CustomerUi>> {
  //   let url = `${this.baseURL}api/customer/create`
  //   if (organizationCd) {
  //     url = `${url}?organizationCd=${organizationCd}`
  //   }
  //   const ret$ = this.httpRequestService.post<CustomerUi>(url, payload)
  //   return await lastValueFrom(ret$)
  // }

  // // 顧客情報更新
  // async Update(payload: CustomerUi): Promise<ResultInfoSingle<CustomerUi>> {
  //   const url = `${this.baseURL}api/customer/update`
  //   const ret$ = this.httpRequestService.putResultSingle<CustomerUi>(url, payload)
  //   return await lastValueFrom(ret$)
  // }


  // 新規作成
  // async CreateAccountWithCustomer(payload: AccountwithCustomer): Promise<ResultInfoSingle<AccountwithCustomer>> {
  //   let url = `${this.baseURL}/api/customer/createAccount`
  //   const ret$ = this.httpRequestService.postResultSingle<AccountwithCustomer>(url, payload)
  //   return await lastValueFrom(ret$)
  // }
  async CreateAccountWithCustomer(payload: AccountwithCustomer): Promise<any> {
    const apiProfileId = 'f3d97385-e77a-4844-9923-69c5d8708c6b';
    const body = { 
      model: payload 
    };
    const ret$ = this.bizTaskApiServeice.executeTask(body, apiProfileId)
    return await lastValueFrom(ret$);
  }

  // ニックネーム検索
  // async NicknameSearch(nickname: string): Promise<any> {
  //   const url = `${this.baseURL}/api/accounts/checkDuplicate?nickName=${nickname}`
  //   const ret$ = this.httpRequestService.get<any>(url)
  //   return await lastValueFrom(ret$)
  // }
  async NicknameSearch(nickname: string): Promise<any> {
    const apiProfileId = '3a94e1d2-d782-4839-b6e8-5212d61e1579';
    const body = {nickName: nickname};
    const ret$ = this.bizTaskApiServeice.executeTask(body, apiProfileId)
    return await lastValueFrom(ret$)
  }
}
